import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";

export const CarteraSelect = ({ value, onChange, className = "" }) => {
  return (
    <FormControl fullWidth className={className}>
      <InputLabel id="demo-simple-select-label-cartera">Cartera</InputLabel>
      <Select
        size="small"
        labelId="demo-simple-select-label-cartera"
        id="demo-simple-select-cartera"
        value={value}
        label="Cartera"
        onChange={(event) => onChange(event.target.value)}
      >
        <MenuItem value={"V"}>Vencida</MenuItem>
        <MenuItem value={"P"}>Por Vencer</MenuItem>
      </Select>
    </FormControl>
  );
};

export const LineaSelect = ({ value, onChange, className = "" }) => {
  return (
    <FormControl fullWidth className={className}>
      <InputLabel id="demo-simple-select-label-linea">Línea</InputLabel>
      <Select
        size="small"
        labelId="demo-simple-select-label-linea"
        id="demo-simple-select-linea"
        value={value}
        label="Línea"
        onChange={(event) => onChange(event.target.value)}
      >
        <MenuItem value={"O"}>Operación</MenuItem>
        <MenuItem value={"R"}>Revolvente</MenuItem>
      </Select>
    </FormControl>
  );
};
